module.exports = __webpack_public_path__ + "static/img/de.c7f2bcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/de.jpg
// module id = tRLN
// module chunks = 0